export const REDUX_MARKET_TYPES = { RECENT_ITEM: 'RECENT_ITEM' }

export const dispatchRecentItem = (item) => (dispatch) => dispatch({
  type: REDUX_MARKET_TYPES.RECENT_ITEM,
  payload: item
})
